<template>
    <ResponsiveDialog
        v-model="internalValue"
        :max-width="900"
        color="warning"
        header-class="skin-window-header--skillpopup"
        :header-title="headerTitle"
        card-class="skin-card"
    >
        <template v-if="pokemonType">
            <v-card-text class="justify-center skill-popup__scroll skin-window--skillpopup">
                <div class="skill-popup__medallion">
                    <v-img :src="getIcon()" contain/>
                </div>
                <SkillListTable :items="skills" @open-detail="openDetail"/>
                <p v-if="pokemonType.isDitto">
                    {{ $t('pokedex.skillPopup.dittoNote') }}
                </p>
                <!-- prazdny pruh o vysce plovouciho oranzoveho krizku (ResponsiveDialog, mobil) -
                     aby posledni radky skillu po doscrollovani nebyly schovane pod nim -->
                <div class="skill-popup__scroll-spacer"/>
            </v-card-text>
        </template>

        <SkillDetailPopup v-model="detailOpen" :skill="selectedSkill" :known-obstacle-types="knownObstacleTypes"/>
    </ResponsiveDialog>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import ResponsiveDialog from "@/components/utils/ResponsiveDialog";
    import SkillListTable from "@/components/pokedex/SkillListTable";
    import SkillDetailPopup from "@/components/pokedex/SkillDetailPopup";
    import {API_ENTRYPOINT} from "@/config/entrypoint";
    import {pokemonImageSrc} from '@/utils/pokemonImage';

    export default {
        name: 'SkillPopup',
        components: {ResponsiveDialog, SkillListTable, SkillDetailPopup},
        props: {
            value: {type: Boolean, default: false},
            pokemonType: {type: Object, default: null},
        },
        data() {
            return {
                skills: [],
                loadedForId: null,
                selectedSkill: null,
                detailOpen: false,
                trainerItem: null,
            }
        },
        computed: {
            ...mapGetters({
                user: 'user/item',
            }),
            internalValue: {
                get() {
                    return this.value;
                },
                set(v) {
                    this.$emit('input', v);
                },
            },
            // Trainer::getKnownObstacleTypes() - "You know, this skill
            // breaks..." v SkillDetailPopup.vue.
            knownObstacleTypes() {
                return this.trainerItem ? this.trainerItem.knownObstacleTypes : [];
            },
            headerTitle() {
                if (!this.pokemonType) return '';
                return this.$t('pokedex.skillPopup.headerTitle', {name: this.pokemonType.name, cost: this.pokemonType.totalSkillCost});
            },
        },
        watch: {
            value(isOpen) {
                if (isOpen) {
                    this.loadSkills();
                }
            },
            pokemonType() {
                this.skills = [];
                this.loadedForId = null;
                if (this.value) {
                    this.loadSkills();
                }
            },
        },
        created() {
            this.loadTrainer(this.user.id).then((data) => {
                this.trainerItem = data;
            });
        },
        methods: {
            ...mapActions('pokemon', [
                'fetchObject'
            ]),
            ...mapActions({
                loadTrainer: 'trainer/loadItem',
            }),
            loadSkills() {
                if (!this.pokemonType || this.loadedForId === this.pokemonType.id) {
                    return;
                }
                const relativePath = `/api/pokemon_type/skills/${this.pokemonType.id}`;
                let url = new URL(relativePath, API_ENTRYPOINT);
                url.searchParams.set("itemsPerPage", 150);
                let obj = {url: url, method: 'GET'};
                this.fetchObject(obj).then((data) => {
                    this.skills = data.skills;
                    this.loadedForId = this.pokemonType.id;
                });
            },
            openDetail(skill) {
                this.selectedSkill = skill;
                this.detailOpen = true;
            },
            getIcon() {
                return this.pokemonType ? pokemonImageSrc(this.pokemonType.img) : null;
            },
        },
    }
</script>

<style scoped>
    .skill-popup__medallion {
        width: 80px;
        height: 80px;
        margin: 0 auto 8px;
    }

    .skill-popup__scroll {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
    }

    .skill-popup__scroll-spacer {
        /* stejna hodnota jako ostatni "rezerva pro zaviraci krizek" mista v appce. */
        height: var(--responsive-dialog-close-clearance);
    }
</style>
